import moment from 'moment'
import { DateTimeFormatSimpleOnlyOne } from './datetime'

export function ssjssFilingPrintBody(data: any) {
  const tenantName = data?.tenantName
  const dataList = data?.data
  let dataStr = ''

  for (let j = 0; j < dataList.length; j++) {
    dataStr +=
      '<div style="display: table;width: 100%;justify-content: center;align-items: center;box-sizing: border-box;border-right: 1px solid #000000;border-left: 1px solid #000000;border-bottom: 1px solid #000000;text-align: center;">'
    +
      '<div style="width:55%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">'
    +
      (dataList[j].procedureName || '')
    +
      '</div>'
    +
      '<div style="width:25%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">'
    +
      (dataList[j].primaryCode || '')
    +
      '</div>'
    +
      '<div style="width:20%;display: table-cell;box-sizing: border-box;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">'
    +
      (dataList[j].surgeryLevel || '')
    +
      '</div>'
    +
      '</div>'
  }

  const contents =
    '<div style="page-break-after:always;page-break-inside:always;page-break-before:always;">'
    +
    '<div style="text-align: left;padding-bottom: 8px;font-weight: 600;font-size:13px">'
    +
    ' <div style="display: inline-block;width: 100%;text-align: left;">机构名称:'
    +
    '<font style="font-weight: 300;">'
    +
    tenantName
    +
    '</font>'
    +
    '</div>'
    +
    '</div>'
    +
    '<div style="display: table;width: 100%;justify-content: center;align-items: center;box-sizing: border-box;border-right: 1px solid #000000;border-left: 1px solid #000000;border-top: 1px solid #000000;border-bottom: 1px solid #000000;text-align: center;">'
    +
    '<div style="width:55%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">手术操作名称'
    +
    '</div>'
    +
    '<div style="width:25%;display: table-cell;box-sizing: border-box;border-right: solid 1px #000000;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">编码'
    +
    '</div>'
    +
    '<div style="width:20%;display: table-cell;box-sizing: border-box;font-size: 8px;font-weight: bold;word-break:break-all;vertical-align: middle;text-align: center;">手术级别'
    +
    '</div>'
    +
    '</div>'
    +
    dataStr
    +
    '</div>'
  return contents
}